import type { LeaderboardEntry } from "../shared/competition.ts";
import { formatElapsed } from "./storage.ts";

export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;",
  })[character] ?? character);
}

export function leaderboardTable(entries: LeaderboardEntry[], ownId?: string): string {
  if (!entries.length) return '<p class="leaderboard-empty">No times posted yet.</p>';
  return `<table class="leaderboard-table">
    <caption class="sr-only">Fastest 50 solves, with attempts breaking ties</caption>
    <thead><tr><th scope="col">Rank</th><th scope="col">Name</th><th scope="col">Time</th><th scope="col">Attempts</th></tr></thead>
    <tbody>${entries.map((entry) => `<tr ${entry.id === ownId ? 'class="your-score"' : ""}>
      <td>${entry.rank}</td><th scope="row">${escapeHtml(entry.name)}${entry.id === ownId ? ' <span class="score-you">You</span>' : ""}</th>
      <td>${formatElapsed(entry.elapsedMs)}<span class="time-fraction">.${Math.floor(entry.elapsedMs % 1000 / 10).toString().padStart(2, "0")}</span></td>
      <td>${entry.attempts}/${entry.maxAttempts}</td>
    </tr>`).join("")}</tbody>
  </table>`;
}